import "./InsightCardsContainer.css";

export const InsightCardsContainer: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return <div className="insight-cards">{children}</div>;
};
